module.exports = __webpack_public_path__ + "static/cards-20c5befde67d2711ca7d97d9f02dcd34.jpg";